var m = require('mithril');
var prop = require('mithril/stream');
var requestStatusHandler = require('./requestStatusHandler');
var RequestStatus = require('../enums/RequestStatus');

function statusCode(error) {
  var value = error && (error.status || error.statusCode || error.code || (error.response && error.response.status));
  var code = Number(value);
  return Number.isFinite(code) ? code : null;
}

function initialize(ctrl) {
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop(null);
}

function run(ctrl, request, options) {
  options = options || {};
  ctrl.requestStatus(RequestStatus.PENDING);
  ctrl.requestStatusCode(null);

  return Promise.resolve()
    .then(request)
    .then(function (result) {
      ctrl.requestStatus(RequestStatus.SUCCESS);
      return result;
    })
    .catch(function (error) {
      // Initial reads must always settle into a visible, retryable UI state.
      // Returning null also prevents a route-initiated request from becoming an
      // unhandled browser rejection.
      console.error(options.errorMessage || 'Unable to load page data:', error);
      ctrl.requestStatusCode(statusCode(error));
      ctrl.requestStatus(RequestStatus.ERROR);
      return null;
    });
}

function view(ctrl) {
  if (!ctrl.requestStatus || ctrl.requestStatus() === RequestStatus.SUCCESS) return null;
  return m(requestStatusHandler, {
    requestStatus: ctrl.requestStatus,
    requestStatusCode: ctrl.requestStatusCode,
    onRetry: ctrl.init
  });
}

module.exports = {
  initialize: initialize,
  run: run,
  view: view,
  _test: {
    statusCode: statusCode
  }
};
